import { useEffect, useState } from "react";


import { FormControl } from "@mui/material";
import { FormHelperText } from "@mui/material";

export const GenderSelector = ({ name, setValue, gender, setGender, errors, columnCheck = false }) => {

    const selectGender = (gender) => {
        setGender(gender);
        setValue(name, gender, { shouldValidate: true, shouldDirty: true });
        
    };

    return (
        <FormControl error={!!errors.gender}>
            <div className="flex gap-6 justify-center">
                <button
                    disabled={columnCheck}
                    className={`${gender == "male" ? " bg-[#E2F0FF] border-blue-500 text-blue-700 " : " text-[#70829B] "
                        }  border rounded-3xl flex justify-center p-1 px-2 text-center`}
                    onClick={(e) => { e.preventDefault();  e.stopPropagation(); selectGender('male') }}
                >
                    <img src="https://views.medibuddy.in/providerUi/assets/Male.svg" alt="" />
                    <p className="text-center py-2 px-1 flex justify-center text-sm font-normal">
                        Male
                    </p>
                </button>

                <button
                    disabled={columnCheck}
                    className={`${gender == "female" ? " bg-[#E2F0FF] border-blue-500 text-blue-700 " : " text-[#70829B] "
                        }  border rounded-3xl flex justify-center p-1 px-3 text-center`}
                    onClick={(e) => { e.preventDefault();   e.stopPropagation(); selectGender('female') }}
                >
                    <img src="https://views.medibuddy.in/providerUi/assets/Female.svg" alt="" />
                    <p className="text-center py-2 px-1 flex justify-center text-sm font-normal ">
                        Female
                    </p>
                </button>

                <button
                    disabled={columnCheck}
                    className={`${gender == "others" ? " bg-[#E2F0FF] border-blue-500 text-blue-700 " : " text-[#70829B] "
                        }  border rounded-3xl flex justify-center p-1 px-2 text-center`}
                    onClick={(e) => { e.preventDefault();  e.stopPropagation();  selectGender('others') }}
                >
                    <img src="https://views.medibuddy.in/providerUi/assets/Others.svg" alt="" className="z-10 " />
                    <p className="text-center py-2 px-1 flex justify-center text-sm font-normal">
                        Others
                    </p>
                </button>
            </div>

            {errors.gender && <FormHelperText style={{ paddingLeft: '-4px' }}>{errors.gender.message}</FormHelperText>}

        </FormControl>
    );
};